import React from 'react';
import { withStyles, Grid, } from '@material-ui/core';
import { withRouter } from 'react-router-dom';
import LiveValidity from './LiveValidity';
import LiveContent from './LiveContent';

import Swiper from 'react-id-swiper';
import Apis from '../../network/Apis';

class LiveList extends React.Component {

    constructor(props) {
        super(props);
        this.params = {
            slidesPerView: 'auto',
            spaceBetween: 8,
            nums: 0,
        };
        this.state = {
            recommMatch: [],
        }
    }

    componentDidMount() {
        this.getRecommMatch();
    }

    componentWillUnmount() {
        this.setState = () => false;
    }

    getRecommMatch = async () => {
        let result = await Apis.encryptionRecommMatch();
        console.log('getRecommMatch', result);
        if (result.code == 200) {
            this.setState({ recommMatch: result.data });
        }
    }



    render() {
        const { classes } = this.props;
        const { recommMatch } = this.state;
        return (
            <Grid container direction='row' alignItems='center' className={classes.root}>
                <Grid container direction='row' alignItems='center' className={classes.container}>
                    {
                        recommMatch && recommMatch.length > 0 && <Swiper {...this.params}>
                            <Grid container alignItems='center' style={{ width: 70, height: 100, marginLeft: 8 }}>
                                <LiveValidity data={recommMatch.length} />
                            </Grid>
                            {
                                recommMatch && recommMatch.map((item, i) => (
                                    <Grid key={i} container alignItems='center' style={{ width: 185, height: 100 }}>
                                        <LiveContent data={item} />
                                    </Grid>
                                ))
                            }
                        </Swiper>
                    }
                </Grid>
            </Grid>
        );
    }
}

export default withRouter(withStyles((theme) => ({
    root: {
        width: '100vw',
        height: 100,
    },
    container: {
        width: '100vw',
        height: 100,
        backgroundColor: '#FFF',
        backgroundSize: '100% 100%',
        padding: theme.spacing(0, 0, 0, 0),
    }

}))(LiveList));